<template>
    <Head>
        <title>Orders</title>
    </Head>

    <authenticated-layout :notifications="notifications" >

        <template #header>
            <organization-nav v-if="organizationId" :organization-id="organizationId"/>
        </template>

        <div class="bg-white text-sm p-4" v-if="success">
            <form
                class="flex flex-row justify-end items-bottom gap-4 p-4"
                @submit.prevent="filter"
            >
                <div class="w-96">
                    <v-input placeholder="Поиск по ID/адресу/хешу" type="search" v-model="search"/>
                </div>
                <v-button>Найти</v-button>
            </form>

            <div
                :key="order.id"
                v-for="order of orders"
                class="flex flex-col border-b"
            >
                <div class="grid grid-cols-6 p-2 gap-2">
                    <div class="col-span-2 flex flex-col">
                        <div class="grid grid-cols-4 gap-x-2" v-if="order.organization">
                            <Link class="col-start-2 col-span-3 text-blue-700" :href="route('organization.orders', order.organization.id)">
                                {{ order.organization.name }}
                            </Link>
                        </div>
                        <div class="grid grid-cols-4 gap-x-2">
                            <label for="" class="text-right text-gray-500 uppercase">ID</label>
                            <span class="col-span-3">{{ order.id }}</span>
                        </div>
                        <div class="grid grid-cols-4 gap-x-2">
                            <label for="" class="text-right text-gray-500 uppercase">Address</label>
                            <span class="col-span-3">{{ order.address }}</span>
                        </div>
                        <div class="grid grid-cols-4 gap-x-2">
                            <label for="" class="text-right text-gray-500 uppercase">Order</label>
                            <span class="col-span-3">{{ order.order }}</span>
                        </div>
                        <div class="grid grid-cols-4 gap-x-2">
                            <label for="" class="text-right text-gray-500 uppercase">Description</label>
                            <span class="col-span-3">{{ order.description }}</span>
                        </div>
                    </div>
                    <div class="flex flex-col">
                        <div class="grid grid-cols-2 gap-x-2">
                            <label for="" class="text-right text-gray-500 uppercase">Status</label>
                            <span class="uppercase">{{ order.status }}</span>
                        </div>
                        <div class="grid grid-cols-2 gap-x-2">
                            <label for="" class="text-right text-gray-500 uppercase">Coin</label>
                            <span>{{ order.currencies.name }} {{ `(${order.network.name})` }}</span>
                        </div>
                        <div class="grid grid-cols-2 gap-x-2">
                            <label for="" class="text-right text-gray-500 uppercase">Amount</label>
                            <span>{{ order.amount }} {{ `(${parseFloat(order.amountUSD).toFixed(2)}$)`}}</span>
                        </div>
                        <div class="grid grid-cols-2 gap-x-2">
                            <label for="" class="text-right text-gray-500 uppercase">Received</label>
                            <span>{{ order.received }} {{ `(${ parseFloat(order.receivedUSD).toFixed(2) }$)` }}</span>
                        </div>
                    </div>
                    <div class="col-span-2 flex flex-col">
                        <div class="grid grid-cols-4 gap-x-2">
                            <label for="" class="text-right text-gray-500 uppercase">Source</label>
                            <span class="col-span-3">{{ order.source }}</span>
                        </div>
                        <div class="grid grid-cols-4 gap-x-2">
                            <label for="" class="text-right text-gray-500 uppercase">Return Url</label>
                            <span class="col-span-3">{{ order.returnUrl }}</span>
                        </div>
                        <div class="grid grid-cols-4 gap-x-2">
                            <label for="" class="text-right text-gray-500 uppercase">Success Webhook</label>
                            <span class="col-span-3">{{ order.successWebhook }}</span>
                        </div>
                        <div class="grid grid-cols-4 gap-x-2">
                            <label for="" class="text-right text-gray-500 uppercase">Error Webhook</label>
                            <span class="col-span-3">{{ order.errorWebhook }}</span>
                        </div>
                    </div>
                    <div class="flex flex-col">
                        <div class="grid grid-cols-2 gap-x-2 items-center">
                            <label for="" class="text-right text-gray-500 uppercase">Create (UTC)</label>
                            <span class="uppercase text-center">
                                {{ order.createdAt ? moment(order.createdAt).utc().format('L') : '' }}<br>
                                {{ order.createdAt ? moment(order.createdAt).utc().format('LTS') : '' }}
                            </span>
                        </div>
                        <div class="grid grid-cols-2 gap-x-2 items-center">
                            <label for="" class="text-right text-gray-500 uppercase">Update (UTC)</label>
                            <span class="uppercase text-center">
                                {{ order.updatedAt ? moment(order.updatedAt).utc().format('L') : '' }}<br>
                                {{ order.updatedAt ? moment(order.updatedAt).utc().format('LTS') : '' }}
                            </span>
                        </div>
                        <div class="flex flex-row justify-end gap-4">
                            <span
                                class="text-blue-700 cursor-pointer uppercase"
                                :class="{ 'bg-blue-200': order.transactionsShow }"
                                v-if="order.transactions.length > 0"
                                @click="order.transactionsShow = !order.transactionsShow; order.invoiceShow = false"
                            >
                                Transactions ({{ order.transactions.length }})
                            </span>
                            <span
                                class="text-blue-700 cursor-pointer uppercase"
                                :class="{ 'bg-blue-200': order.invoiceShow }"
                                v-if="order.invoice"
                                @click="order.invoiceShow = !order.invoiceShow; order.transactionsShow = false"
                            >
                                Invoice
                            </span>
                        </div>
                    </div>
                </div>

                <div
                    class="grid grid-cols-12 border-t border-x bg-gray-50 py-2 gap-x-2"
                    v-if="order.transactionsShow ||  false"
                    v-for="transaction in order.transactions"
                >

                    <div class="col-span-5 flex flex-row gap-2 pb-2">
                        <label class="text-gray-500 uppercase">Id</label>
                        <code>{{ transaction.id}}</code>
                    </div>
                    <div class="col-span-7 flex flex-row gap-2">
                        <label class="text-gray-500 uppercase">Hash</label>
                        <code>{{ transaction.transactionHash}}</code>
                    </div>

                    <div class="col-start-2 col-span-2 text-gray-500 text-right uppercase">Amount</div>
                    <div class="text-gray-500 uppercase">Coin</div>
                    <div class="text-gray-500 uppercase">Status</div>
                    <div class="text-gray-500 uppercase">Confirmation</div>
                    <div class="col-span-4 text-gray-500 uppercase">Senders</div>
                    <div class="text-gray-500 uppercase text-center">Create (UTC)</div>
                    <div class="text-gray-500 uppercase text-center">Update (UTC)</div>

                    <div class="flex flex-row gap-x-4 items-center">
                        <svg v-if="transaction.confirmed" xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 fill-current text-green-500" viewBox="0 0 16 16">
                            <title>Confirmed</title>
                            <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z"/>
                        </svg>
                        <svg v-if="transaction.type === 'in'" xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 fill-current text-blue-500" viewBox="0 0 16 16">
                            <title>In Type</title>
                            <path fill-rule="evenodd" d="M3.5 10a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 0 0 1h2A1.5 1.5 0 0 0 14 9.5v-8A1.5 1.5 0 0 0 12.5 0h-9A1.5 1.5 0 0 0 2 1.5v8A1.5 1.5 0 0 0 3.5 11h2a.5.5 0 0 0 0-1z"/>
                            <path fill-rule="evenodd" d="M7.646 15.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 14.293V5.5a.5.5 0 0 0-1 0v8.793l-2.146-2.147a.5.5 0 0 0-.708.708z"/>
                        </svg>
                        <svg v-if="transaction.type === 'out'" xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 fill-current text-red-500" viewBox="0 0 16 16">
                            <title>Out Type</title>
                            <path fill-rule="evenodd" d="M3.5 6a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 1 0-1h2A1.5 1.5 0 0 1 14 6.5v8a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 14.5v-8A1.5 1.5 0 0 1 3.5 5h2a.5.5 0 0 1 0 1z"/>
                            <path fill-rule="evenodd" d="M7.646.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 1.707V10.5a.5.5 0 0 1-1 0V1.707L5.354 3.854a.5.5 0 1 1-.708-.708z"/>
                        </svg>
                    </div>
                    <div class="col-span-2 flex flex-col text-right">
                        <span>{{ transaction.amount }}</span>
                        <small>{{ parseFloat(transaction.amountUSD).toFixed(2) }}$</small>
                    </div>
                    <div>{{ transaction.currency.name }} {{ `(${transaction.network.name})` }}</div>
                    <div class="uppercase">{{ transaction.status }}</div>
                    <div>{{ transaction.confirmationsExpected }}/{{ transaction.confirmations }}</div>
                    <div class="col-span-4 flex flex-col">
                        <span v-for="sender of transaction.senders">{{ sender }}</span>
                    </div>
                    <div class="text-center">
                        {{ transaction.createdAt ? moment(transaction.createdAt).utc().format('L LTS') : '' }}
                    </div>
                    <div class="text-center">
                        {{ transaction.updatedAt ? moment(transaction.updatedAt).utc().format('L LTS') : '' }}
                    </div>

                </div>


                <div
                    class="grid grid-cols-12 border-t border-x bg-gray-50 py-2 gap-x-2"
                    v-if="order.invoiceShow ||  false"
                >

                    <div class="col-span-4 flex flex-row gap-2 pb-2">
                        <label class="text-gray-500 uppercase">Id</label>
                        <code>{{ order.invoice.id}}</code>
                    </div>
                    <span class="col-span-3 text-center text-gray-500 uppercase pt-2">Received</span>
                    <div class="col-span-5"></div>

                    <div class="text-gray-500 uppercase">Status</div>
                    <div class="col-span-2 text-gray-500 text-right uppercase">Amount</div>
                    <div class="text-gray-500 uppercase">Currency</div>
                    <div class="col-span-2 text-gray-500 text-right uppercase">Amount</div>
                    <div class="text-gray-500 uppercase">Currency</div>
                    <div class="col-span-2"></div>
                    <div class="text-gray-500 uppercase text-center">Create (UTC)</div>
                    <div class="text-gray-500 uppercase text-center">Apply (UTC)</div>
                    <div class="text-gray-500 uppercase text-center">Update (UTC)</div>

                    <div class="uppercase">{{ order.invoice.status }}</div>
                    <div class="col-span-2 flex flex-col text-right">
                        <span>{{ order.invoice.amount }}</span>
                        <small>{{ parseFloat(order.invoice.amountUSD).toFixed(2) }}$</small>
                    </div>
                    <div>{{ order.invoice.currency.name }}</div>
                    <div class="col-span-2 flex flex-col text-right">
                        <span>{{ order.invoice.receivedAmount }}</span>
                        <small>{{ parseFloat(order.invoice.receivedAmountUSD).toFixed(2) }}$</small>
                    </div>
                    <div>{{ order.invoice.currencyReceived.name }}</div>
                    <div class="col-span-2"></div>
                    <div class="text-center">
                        {{ order.invoice.createdAt ? moment(order.invoice.createdAt).utc().format('L LTS') : '' }}
                    </div>
                    <div class="text-center">
                        {{ order.invoice.applyAt ? moment(order.invoice.applyAt).utc().format('L LTS') : '' }}
                    </div>
                    <div class="text-center">
                        {{ order.invoice.updatedAt ? moment(order.invoice.updatedAt).utc().format('L LTS') : '' }}
                    </div>

                </div>

            </div>

            <v-pagination
                class="py-6 px-4"
                :count="total"
                :page="page"
                :limit="limit"
                :paginate="paginate"
            />

        </div>

    </authenticated-layout>

</template>

<script>
import {Head, Link, useForm} from '@inertiajs/inertia-vue3';
import AuthenticatedLayout from '@/Layouts/Authenticated';
import OrganizationNav from '@/Components/Navigation/Organization';
import VInput from "@/Components/Input";
import VButton from "@/Components/Button";
import VSelect from "@/Components/Select";
import moment from "moment";
import VPagination from "@/Components/PaginationOffset.vue";
import OrganizationNavigation from "@/Components/Navigation/Organization.vue";

export default {
    components: {
        OrganizationNavigation,
        VPagination,
        Head, Link,
        AuthenticatedLayout,
        OrganizationNav,
        VInput,
        VButton,
        VSelect,
    },
    props: {
        notifications: Object,
        success: Boolean,
        orders: Object,
        total: Number,
        page: Number,
        offset: Number,
        limit: Number,
        search: String | null,
        organizationId: String | null,
    },
    methods: {
        moment,
        filter() {
            const { search, organizationId } = this;
            useForm({ search })
                .get(organizationId ? this.route('organization.orders', organizationId) : this.route('orders'));
        },
        paginate(page) {
            const { search, organizationId } = this;
            useForm({ search, page })
                .get(organizationId ? this.route('organization.orders', organizationId) : this.route('orders'));
        },
    },
}
</script>
